import {TextAreaProps} from '@/components/commons/textarea/TextArea'
import {forwardRef, useMemo} from 'react'
import {MedicalReportTextAreaField} from '../medical-report-text-area-field/MedicalReportTextAreaField'
import {MedicalReportTextAreaModal} from '../medical-report-text-area-modal/MedicalReportTextAreaModal'
import {PreviousMedicalReportProvider} from '../../contexts/PreviousMedicalReportContext'
import {useMedicalReportTextAreaStore} from '../../stores/medicalReportTextAreaStore'

interface ExpandableTextAreaProps extends TextAreaProps {
    title: string
    description?: string
    previousReport?: string
    currentField: string
}

export const MedicalReportTextArea = forwardRef<HTMLTextAreaElement, ExpandableTextAreaProps>(
    ({previousReport, ...props}, ref) => {
        const {selectedField} = useMedicalReportTextAreaStore()
        const textAreaProps = useMemo(() => ({...props, rows: 18}), [props])

        return (
            <PreviousMedicalReportProvider value={{previousReport}}>
                <MedicalReportTextAreaField {...props} ref={ref} canSplit={false} />
                {!!selectedField && selectedField == props.currentField && (
                    <MedicalReportTextAreaModal
                        ref={ref}
                        title={props.title}
                        description={props.description}
                        textAreaProps={{
                            ...textAreaProps,
                            errorMessage: ''
                        }}
                    />
                )}
            </PreviousMedicalReportProvider>
        )
    }
)
